import React from 'react';

import { useTranslation } from '@modernloop/i18n';
import { Box, Button, Chip, Divider, Stack, Typography } from '@mui/material';

import { Permission } from 'src/generated/mloop-graphql';

import { useIsMissingUserPermission } from 'src/hooks/api/user/get';
import useHistory from 'src/hooks/useHistory';

import getTaskSettingsTabUrl from 'src/urls/getTaskSettingsTabUrl';

// eslint-disable-next-line modernloop/restrict-imports.cjs
import { TaskSettingsTabs } from 'src/views-new/Settings/types';

export const TaskQueueSelectZeroState = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const disabled = useIsMissingUserPermission(Permission.CanManageOrgSettings);
  const onAddQueue = () => {
    const redirectUrl = getTaskSettingsTabUrl(TaskSettingsTabs.TASK_QUEUE, true);
    history.push(redirectUrl);
  };

  return (
    <Box mt={1}>
      <Stack rowGap={1}>
        <Divider />
        <Box p={1.5} bgcolor="info.tint" borderRadius="6px" position="relative">
          <Box textAlign="center">
            <Box
              sx={{
                position: 'absolute',
                top: 10,
                left: 10,
              }}
            >
              <Chip
                label={t('hiring-dashboard-settings-tasks:settings.tasks.queues.zeroStateChip')}
                color="warning"
                size="small"
                variant="filled"
              />
            </Box>
            <Box pt={2}>
              <img
                width="64px"
                height="64px"
                src="/static/images/setup/queues.svg"
                alt={t('hiring-dashboard-settings-tasks:settings.tasks.queues.avatarAlt')}
              />
            </Box>
          </Box>
          <Stack rowGap={2.5}>
            <Stack rowGap={1} textAlign="center">
              <Typography variant="h5" color="text.primary">
                {t('hiring-dashboard-settings-tasks:settings.tasks.queues.zeroStateTitle')}
              </Typography>
              <Typography variant="body1" color="text.primary">
                {t('hiring-dashboard-settings-tasks:settings.tasks.queues.zeroStateDescription')}
              </Typography>
            </Stack>
            <Button variant="contained" color="primary" disabled={disabled} onClick={onAddQueue}>
              {t('hiring-dashboard-settings-tasks:settings.tasks.queues.newQueue')}
            </Button>
          </Stack>
        </Box>
      </Stack>
    </Box>
  );
};
